// @ts-ignore
let environment = window.iDonateConfig;

const setEnv = (env) => {
  environment = env;
};

export {environment, setEnv};

